import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { useLocale } from 'next-intl'
import { useRouter } from 'next/navigation'
import useGetItineraryId from '../../itinerary/useGetItineraryId'

const useRedirectToPage = () => {
    const itineraryId = useGetItineraryId()
    const locale = useLocale()
    const router = useRouter()

    const redirectToPage = ({ pageName = '', method = 'push' }) => {
        if (!isEmpty(pageName)) {
            const pathname = `/${locale}/flights/itinerary/${itineraryId}/${pageName}`
            if (method === 'push') {
                router.push(pathname)
            } else {
                router.replace(pathname)
            }
        }
    }

    return redirectToPage
}

export default useRedirectToPage
